import {useEffect, useState, useRef} from 'react';
import Slider from './slider';
// import Tabs from './tabs';
import TabsNew from './tabs_new';

export default () => {
    const [scale, setScale] = useState(1),
          [sliderScale, setSliderScale] = useState(1),
          [bottomMargin, setBottomMargin] = useState(0),
          [tabsMargin, setTabsMargin] = useState(0),
          leftRef = useRef(),
          topRef = useRef(),
          location = "/";

    const resizeHandler = () => {
        const width = document.body.offsetWidth,
              top_width = topRef.current ? topRef.current.offsetWidth : 0;

        // if(width < 1400 && width > 800) {
        //     console.log(width);
        //     const next_scale = (width - 40) / 1380;
        //     setScale(next_scale);
        // }  else {
        //     setScale(1);
        // }

        // const width = document.body.offsetWidth,
        //       width_mobile = leftRef.current ? leftRef.current.offsetWidth : 0,
        //       width_desktop = topRef.current ? topRef.current.offsetWidth : 0,
        //       koef = width_mobile / 400;



        // // Top block scale
        // if(width <= 1267 && width > 800) {
        //     const nextScale = width_desktop / 1218;

        //     setScale(nextScale);
        //     setBottomMargin((413 * nextScale) - 413);
        // } else {
        //     setScale(1);
        //     setBottomMargin(0);
        // }

        // // Mobile slider scale
        // if(width <= 800) {
        //     setSliderScale(width_mobile / 400);
        //     setTabsMargin((268 * koef) - 268);
        // } else {
        //     setSliderScale(1);
        //     setTabsMargin(0);
        // }
    }

    useEffect(() => {
        resizeHandler();
        
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, [location]);

    return (
        <div className="top" ref={topRef}>
            <div className="left" ref={leftRef}>
                <Slider scale={sliderScale} />
            </div>
            <div className="right">
                <TabsNew.VIP />
                <TabsNew.Tournament />
                <TabsNew.Invite />
                <TabsNew.BonusZone />
                {/* <div className="row-2">
                    <Tabs.VIP />
                    <Tabs.Wheel />    
                </div>
                <div className="row-2">
                    <Tabs.Tasks />
                    <Tabs.Refer />
                </div> */}
            </div>
        </div>
    )
}